// extracted by mini-css-extract-plugin
export default {"page-inner":"Menu_page-inner__eGT86","opaque":"Menu_opaque__TLKtl","brwose-menu-btn":"Menu_brwose-menu-btn__6vXWg"};